import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { VirtualCardDetails } from '../../models/virtual-card-details/vitual-card-details.interface';

@Injectable({ providedIn: 'root' })
export class VirtualCardDetailsService {
	private readonly relativeUrl = 'applications/';
	constructor(private readonly http: HttpClient) {}

	getVirtualCardDetails(
		applicationId: number,
		vCardId: string
	): Observable<VirtualCardDetails> {
		return this.http.get<VirtualCardDetails>(
			`${this.relativeUrl}${applicationId.toString()}/virtual-cards/${vCardId}`
		);
	}
}
